// src/utils/flyToCart.js
export function flyImageToCart(imageElement) {
  if (typeof document === "undefined") return;
  if (!imageElement) return;

  const cartIcon = document.getElementById("main-cart-icon");
  if (!cartIcon) return;

  const imgRect = imageElement.getBoundingClientRect();
  const cartRect = cartIcon.getBoundingClientRect();

  const clone = imageElement.cloneNode(true);

  clone.style.position = "fixed";
  clone.style.left = imgRect.left + "px";
  clone.style.top = imgRect.top + "px";
  clone.style.width = imgRect.width + "px";
  clone.style.height = imgRect.height + "px";
  clone.style.zIndex = "999999";
  clone.style.pointerEvents = "none";
  clone.style.transition =
    "transform 0.75s cubic-bezier(.25,.8,.25,1), opacity 0.75s ease-out";
  clone.style.transformOrigin = "center center";
  clone.style.borderRadius = "12px";
  clone.style.overflow = "hidden";

  document.body.appendChild(clone);

  const fromX = imgRect.left + imgRect.width / 2;
  const fromY = imgRect.top + imgRect.height / 2;
  const toX = cartRect.left + cartRect.width / 2;
  const toY = cartRect.top + cartRect.height / 2;

  const translateX = toX - fromX;
  const translateY = toY - fromY;

  // Trigger layout
  requestAnimationFrame(() => {
    // Slight arc: move a bit upwards on the path
    const arcOffsetY = -40;

    clone.style.transform = `translate(${translateX}px, ${
      translateY + arcOffsetY
    }px) scale(0.2)`;
    clone.style.opacity = "0.15";
  });

  clone.addEventListener(
    "transitionend",
    () => {
      clone.remove();
    },
    { once: true }
  );
}
